import { PriceTag } from '@pcln/vip'
import { Text } from 'pcln-design-system'

const TextSpan = Text.span
export default {
  faqsFallback: [
    {
      question: 'How do I become a VIP?',
      answer: (
        <>
          It’s simple — and FREE! All you need is a Priceline account to join the VIP program.
          <br />
          <br />
          Rack up more benefits and perks with each booking you make with Priceline. Every trip gets you
          closer to the next tier, so the more you book, the more you save.
          <br />
          <br />
          Have you booked with Priceline in the past? You may already have VIP status!
        </>
      ),
    },
    {
      question: 'When will my VIP status change?',
      answer: (
        <>
          If your trip qualifies you to graduate to the next tier, you’ll see your VIP tier change 24 hours
          after your trip is complete.
          <br />
          <br />
          You’ll maintain the same tier level from year to year until you advance. However, in order to keep
          the status you’ve earned, you need to book enough qualifying trips every year.
        </>
      ),
    },
    {
      question: 'How can I fast-track my status?',
      answer: (
        <ol>
          <li>
            <strong>Bundle your hotels, flights, and/or rental cars.</strong> Each reservation within a
            bundled trip counts towards your VIP progress.
          </li>
          <br />
          <li>
            <strong>Get the Priceline VIP Rewards™ Visa® Card.</strong> Cardholders automatically become VIP
            Gold members upon account approval. Apply now at{' '}
            {/* eslint-disable-next-line react/jsx-no-target-blank */}
            <a href='https://www.pricelinevisa.com' target='_blank'>
              www.pricelinevisa.com
            </a>{' '}
            and accelerate to Gold!
          </li>

          <br />
          <li>
            <strong>Book! Book! Book!</strong> The more you book, the faster you’ll get to the next VIP tier.
          </li>
        </ol>
      ),
    },
    {
      question: 'Does my VIP status expire?',
      answer: (
        <>
          You’ll always be a VIP member, but in order to keep the status you’ve earned, you need to book
          enough qualifying trips every year.
        </>
      ),
    },
    {
      question: 'Do trips from last year count towards my current VIP status?',
      answer: (
        <>
          No. We only count qualifying trips from January 1st onward towards VIP status for the current year.
          Trips completed in previous years do not count, so keep your focus on future trips!
        </>
      ),
    },
    {
      question: "What if I've booked using more than one email address?",
      answer:
        "We aren't able to merge trips from different email addresses at this time, so be sure to always book with the email associated with your profile.",
    },
    {
      question: 'What happens to my status if I cancel a booking?',
      answer:
        'We get it — plans change! However, cancelled bookings will not count towards your VIP progress.',
    },
    {
      question: 'Can my friends and family members take advantage of my VIP benefits?',
      answer: (
        <>
          VIP benefits tied to your account can only be applied to bookings you make.
          <br />
          <br />
          If you are a Platinum or Gold member, you can share your VIP benefits by creating a VIP Family
          account.
        </>
      ),
    },
    {
      question: 'Can I change or cancel my reservation if I become a VIP?',
      answer:
        'It depends on the type of booking and associated cancellation policy. Cancelled bookings will not be counted towards your VIP progress.',
    },
    {
      question:
        "What happens if I book without signing in or don't have an account? Do those trips still count towards my VIP status?",
      answer: (
        <>
          All bookings made under the email address associated with your VIP account will count towards your
          VIP status even if you aren’t signed in.
          <br />
          Don’t have an account yet? Make sure you create one with the same email used for previous bookings -
          they’ll automatically count towards your VIP status.
        </>
      ),
    },
    {
      question: 'How can I tell which products qualify for VIP discounts?',
      answer: 'Look for the Priceline VIP badge in your search results.',
    },
    {
      question: 'Are the VIP benefits transferable?',
      answer: (
        <>
          Unfortunately, we can’t transfer VIP benefits from one account to another.
          <br />
          Platinum and Gold members can share their VIP benefits by creating a VIP Family account.
        </>
      ),
    },
    {
      question: 'Do I need to spend a certain amount for a booking to count towards my VIP status?',
      answer: 'No. All bookings count toward your VIP status regardless of the purchase amount.',
    },
    {
      question: 'I have the Priceline VIP Rewards™ Visa® Card but I’m not a VIP Gold member?',
      answer: `To be recognized as VIP Gold, your card details in your Priceline profile need to be up-to-date. Sign in to your Priceline profile, select “My Profile” and update your payment information with your 
      Priceline VIP Rewards™ Visa® Card. Be sure to check that your 16-digit card number is correct and that the expiration date is current. Once your card details are updated, please allow 24-48 hours for your VIP status to be updated to Gold.`,
    },
    {
      question:
        'My Priceline VIP Rewards™ Visa® Card is loaded into my Priceline profile, and I’m still not being recognized as a VIP Gold?',
      answer:
        'Be sure to check that your 16-digit card number is correct and that the expiration date is current. Once your card details are updated, please allow 24-48 hours for your VIP status to be updated to Gold.',
    },
    {
      question: 'I don’t have my Priceline VIP Rewards™ Visa® Card information and/or my card has expired?',
      answer: (
        <>
          Please{' '}
          <a href='https://www.barclaycardus.com/servicing/headerLinks?handleContactUs='>contact Barclay’s</a>{' '}
          to obtain your card information and/or to order a replacement card. If you are not a current
          cardmember, you may apply for a new card by visiting{' '}
          {/* eslint-disable-next-line react/jsx-no-target-blank */}
          <a href='https://www.pricelinevisa.com' target='_blank'>
            www.pricelinevisa.com
          </a>
          .
        </>
      ),
    },
    {
      question:
        'My Priceline VIP Rewards™ Visa® Card details are up to date with the expiration date, and it’s still not registering Gold?',
      answer: 'Please contact Priceline Customer Care through chat or SMS text to 33296.',
    },
    {
      question:
        'I just signed up for the Priceline VIP Rewards™ Visa® Card. When will I be considered a VIP Gold member?',
      answer: 'Please allow 24-48 hours for your VIP status to be updated to Gold.',
    },
  ],
  valueProp: {
    contents: [
      {
        id: 1,
        imageSrc:
          'https://s1.pclncdn.com/design-assets/vip/couple-friends-excited-airport-terminal.jpg?opto&auto=avif,webp&width=256&crop=1:1,smart',
        imageAlt: 'Hilarious smiling couple playing at terminal',
        headLine: `Become a member for FREE!\nNo strings attached.`,
      },
      {
        id: 2,
        imageSrc:
          'https://s1.pclncdn.com/design-assets/vip/getaways-waterfront-mountain-cottage.jpg?opto&auto=avif,webp&width=256&crop=1:1,smart',
        imageAlt: 'Beautiful house on a hill overlooking water. Inspirational place to stay on vacations',
        headLine: 'Always get our Best Price.\nGuaranteed.',
      },
      {
        id: 3,
        imageSrc:
          'https://s1.pclncdn.com/design-assets/vip/friends-smiling-group-selfie.jpg?opto&auto=avif,webp&width=256&crop=1:1,smart',
        imageAlt:
          'Happy friends from diverse cultures and races taking selfie with back lighting - Youth and friendship concept with young people having fun together',
        headLine: 'Unlock exclusive VIP discounts and coupons.',
      },
    ],
  },
  zigzag: {
    content: [
      {
        id: 1,
        imageSrc:
          'https://s1.pclncdn.com/design-assets/vip/friends-cheering-mountain-top.jpg?opto&auto=avif,webp&width=600&crop=1:1,smart',
        imageAlt:
          'Big group of people having fun in success pose with raised arms on mountain top against sunset lakes and mountains. Travel, adventure or expedition concept',
        iconName: 'verified',
        iconText: 'Best Price.\nGuaranteed.',
        headLine: 'Your short-cut to\nsavings.',
        subHeadLine:
          "You'll automatically get our best price guarantee so you can spend less time searching for deals and more time traveling.",
        button: 'Sign Up',
      },
      {
        id: 2,
        imageSrc:
          'https://s1.pclncdn.com/design-assets/vip/friends-underwater-pool-selfie.jpg?opto&auto=avif,webp&width=600&crop=1:1,smart',
        imageAlt: 'Young couple smiling under water',
        iconName: 'hotels',
        iconText: 'Travel like\na VIP',
        headLine: 'Get the service you\ndeserve.',
        subHeadLine:
          "From early access to sales to priority customer service, you'll always be our top priority.",
        button: 'Get Started',
      },
      {
        id: 3,
        imageSrc:
          'https://s1.pclncdn.com/design-assets/vip/roadtrip-shoes-car-dashboard.jpg?opto&auto=avif,webp&width=600&crop=1:1,smart',
        imageAlt:
          'Female legs in ripped jeans and blue sneakers inside car with mountains landscape at background. Woman relaxing during road trip',
        iconName: 'cars',
        iconText: 'Hotel and Rental\nCar Discounts',
        headLine: 'Travel large, spend small. Save big on every trip you take.',
        subHeadLine: 'Get even better deals on thousands of hotels and rental cars!',
        button: 'Start Saving!',
      },
    ],
  },
  categories: [
    {
      id: 0,
      label: 'VIP Benefits',
      anchor: 'benefits-table',
    },
    {
      id: 1,
      label: 'VIP Family',
      anchor: 'vip-family',
      icon: <PriceTag pr={2} fontSize='40px' variation='vip' />,
    },
    {
      id: 2,
      label: 'VIP Overview',
      anchor: 'overview',
    },
    {
      id: 3,
      label: 'FAQs',
      anchor: 'faq',
    },
    {
      id: 4,
      label: 'Download the app',
      anchor: 'app-download',
    },
  ],
  imageSrc: 'https://s1.pclncdn.com/design-assets/vip/miniCooper-lg-100.jpg?opto&auto=avif,webp',
  heroContent: {
    headingText: 'Book more, save more.',
    text: 'Unlock huge savings, loyalty perks, and more when you become a VIP.',
  },
  quotes: [
    {
      quote:
        'We can always depend on Priceline for the best rates. We, being VIP members, are always given a discount.',
      customer: {
        name: 'Mrs. Z',
      },
    },
    {
      quote:
        "I've used Priceline ever since I became a frequent traveler. I am now VIP and love all of the deals I get on rooms, flights, cars! You name it!",
      customer: {
        name: 'Jason D',
      },
    },
    {
      quote: "I love using Priceline!! I get great discounts and I'm already VIP and I'm fairly new.",
      customer: {
        name: 'Eli W',
      },
    },
  ],
  firstTextLine: (
    <Text fontSize={1}>
      With a VIP Family account, everyone can unlock bigger savings{' '}
      <TextSpan fontWeight='bold'>5x faster.</TextSpan>
    </Text>
  ),
  familyBenefitsList: [
    <Text key={1}>
      {"Each family member's booking contributes to the "}
      <TextSpan fontWeight='bold'>entire family&apos;s VIP status</TextSpan> for both this year and next year
    </Text>,

    <Text key={2}>
      You <TextSpan fontWeight='bold'>earn savings even when you&apos;re not traveling</TextSpan>, thanks to
      your family members&apos; bookings
    </Text>,

    <Text key={3}>
      {"And when it's your turn to get away, they'll be earning "}
      <TextSpan fontWeight='bold'>bigger savings</TextSpan>, too
    </Text>,
  ],
  lastTextLine: (
    <Text fontSize={1}>
      Add up to five friends or family to your VIP Family account and{' '}
      <TextSpan fontWeight='bold'>supercharge your savings!</TextSpan>
    </Text>
  ),
} as const
